var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65683 19.9447C13.669 19.4953 16.8844 16.288 17.342 12.2759C17.9426 7.02984 13.8651 2.56419 8.75389 2.50699V0.153643C8.75389 0.022901 8.59046 -0.0465555 8.48015 0.0351581L3.63453 3.59379C3.55282 3.65507 3.55282 3.77356 3.63453 3.83484L8.48015 7.39347C8.59046 7.47518 8.75389 7.40164 8.75389 7.27498V4.92572C12.3452 4.98292 15.2215 8.03901 14.9764 11.6916C14.768 14.8335 12.2063 17.383 9.0644 17.5832C5.73457 17.7956 2.9032 15.4177 2.39657 12.2718C2.3026 11.6875 1.79189 11.2626 1.20355 11.2626C0.472217 11.2626 -0.0997785 11.9122 0.0146205 12.6354C0.725529 17.1174 4.86432 20.4799 9.65683 19.9447Z",
    fill: "#EC4E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload__icon.3aac0f1770149183687f9c425c8230f7.svg";
export { ForwardRef as ReactComponent };